// extracted by mini-css-extract-plugin
module.exports = {"accepted":"ConsentStatus_accepted__YCplh","declined":"ConsentStatus_declined__3q6JV","withdrawn":"ConsentStatus_withdrawn__3cRKj"};